import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './Guards/auth.guard';
import { TrialGuard } from './renew/guards/trial.guard';
import { SiteExterneComponent } from './renew/site-externe/site-externe.component';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
};

const routes: Routes = [
    {
        path: 'dashboard',
        component: AppLayoutComponent,
        canActivate: [AuthGuard],
        // canActivateChild (pas canActivate) : se redeclenche a chaque
        // changement de page a l'interieur du dashboard (Angular ne recharge
        // pas ce composant parent entre deux pages), pas seulement au premier
        // acces. Voir TrialGuard pour la page exemptee (Parametres).
        canActivateChild: [TrialGuard],
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./renew/gmao.module').then((m) => m.GmaoModule),
            },
        ],
    },
    {
        path: 'notfound',
        loadChildren: () =>
            import('./demo/components/notfound/notfound.module').then(
                (m) => m.NotfoundModule
            ),
    },
    {
        path: 'public',
        loadChildren: () =>
            import('./renew/public-components/public-components.module').then(
                (m) => m.PublicComponentsModule
            ),
    },
     {
        path: 'login',
        loadChildren: () =>
            import('./demo/components/auth/auth.module').then(
                (m) => m.AuthModule
            ),
    },

    {
        path: '',
        data: { breadcrumb: 'Auth' },
        component:SiteExterneComponent
    },

    // {
    //     path: 'login',
    //     data: { breadcrumb: 'Auth' },
    //     component:Login2Component
    // },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
